/**
 * @description
 * Map a REGISTRATION_FORM field path to the form section it belongs to.
 * Paths follow modules/registration/utils/fieldIdUtils.ts, e.g.
 * groupRegistrations.0.email, groupRegistrations.1.custom.custom_field_12, teamMembers.2.firstname, name
 *
 * isExtraCustomField tells whether a custom field id is a paid extra (CustomFieldTypes.extra)
 */
export function sectionOf(path: string | string[], isExtraCustomField: (id: number) => boolean = () => false): string {
  const parts = (Array.isArray(path) ? path.join('.') : path).split('.');
  const [root, index, field, ...rest] = parts;

  switch (root) {
    case 'currentDistance':
      return 'distance';
    case 'terms':
    case 'distance_terms':
    case 'turnstile_token':
      return 'payment_terms';
    case 'giftcard':
      return 'discount';
    case 'name':
      return 'team';
    case 'class_id':
    case 'wave_id':
      return 'team';
    case 'teamMembers':
      return 'team_members';
    case 'groupRegistrations':
      break;
    default:
      return 'other';
  }

  if (index !== undefined && index !== '0') {
    return 'group_members';
  }

  switch (field) {
    case undefined:
      return 'personal';
    case 'email':
    case 'password':
    case 'password_confirmation':
      return 'account';
    case 'class_id':
    case 'wave_id':
    case 'discipline_id':
    case 'squad_id':
      return 'additional';
    case 'coupon_code':
      return 'discount';
    case 'refund_protect':
      return 'pace_shield';
    case 'payment_method':
    case 'pay_onsite':
      return 'payment_terms';
    case 'open':
    case '_id':
      return 'other';
    case 'custom': {
      const match = /^custom_field_(\d+)$/.exec(rest[0] || '');
      return match && isExtraCustomField(Number(match[1])) ? 'extras' : 'additional';
    }
    default:
      return 'personal';
  }
}
